@if(tab() == 'buy') {
<form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">

  <!-- Header -->
  <div class="bg-[#212529] p-4 mb-4 w-full">
    <h1 class="text-lg md:text-3xl font-semibold text-white">Add Credits</h1>
    <p class="text-gray-300 mt-1 text-sm">Choose credits to power your tasks</p>
  </div>

  <!-- Quick Select Options -->
  <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
    <button *ngFor="let option of creditOptions" type="button" (click)="selectCredits(option.credits)" class="p-3 rounded-lg border-2 transition-all duration-200 hover:scale-105 relative {{
        selectedCredit() == option.credits?'border-blue-500 bg-blue-50 text-blue-700': 'border-gray-300 bg-white text-gray-700 hover:border-gray-400'
      }}">
      <div class="text-center">
        <div class="text-lg font-bold">{{option.credits}}</div>
        <div class="text-xs text-gray-500">Credits</div>
        <div class="text-sm font-medium text-green-600">{{option.price}} AED</div>
        @if(option?.discount) {
        <div
          class="absolute -top-2 -right-2 bg-{{option.discount.color}}-500 text-white text-xs px-2 py-1 rounded-full">
          {{option.discount.percentage}}% OFF
        </div>
        }
      </div>
    </button>
  </div>

  <!-- Custom Amount Input -->
  <div class="bg-gray-50 rounded-lg">
    <h3 class="text-sm font-medium text-gray-700 mb-3">Or enter custom amount:</h3>

    <mat-form-field appearance="outline" class="w-full">
      <div class="flex items-center gap-1 font-medium text-sm">
        <mat-icon class="text-amber-300 text-lg">monetization_on</mat-icon>
        <p mat-label>Credits</p>
      </div>
      <input matInput formControlName="quantity" placeholder="Enter custom amount" pattern="[0-9]*" type="number"
        min="1" max="10000">
      <mat-hint>Min: 1 credit</mat-hint>
      <mat-error>Enter valid credits count (1-10,000)</mat-error>
    </mat-form-field>
  </div>

  <!-- Price Summary -->
  <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
    <div class="flex justify-between items-center mb-2">
      <span class="text-gray-600">Credits:</span>
      <span class="font-medium">{{ checkoutForm.value.quantity || 0 }}</span>
    </div>
    <div class="flex justify-between items-center mb-2">
      <span class="text-gray-600">Rate:</span>
      <span class="font-medium">{{ getRate() }} AED/credit</span>
    </div>
    @if(getDiscount() > 0) {
    <div class="flex justify-between items-center mb-2 text-green-600">
      <span>Discount ({{ getDiscountPercentage() }}%):</span>
      <span class="font-medium">-{{ getDiscount() }} AED</span>
    </div>
    }
    <hr class="my-2 border-gray-300">
    <div class="flex justify-between items-center text-lg font-bold">
      <span>Total:</span>
      <span class="text-green-600">{{ getTotalAmount() }} AED</span>
    </div>
  </div>

  <!-- Payment Methods -->
  <!-- <div class="bg-gray-50 p-4 rounded-lg">
    <h3 class="text-sm font-medium text-gray-700 mb-3">Payment Method:</h3>
    <div class="flex gap-2 flex-wrap">
      <div class="flex items-center gap-2 bg-white p-2 rounded border">
        <mat-icon class="text-blue-600">credit_card</mat-icon>
        <span class="text-sm">Card</span>
      </div>
      <div class="flex items-center gap-2 bg-white p-2 rounded border">
        <mat-icon class="text-green-600">account_balance</mat-icon>
        <span class="text-sm">Bank Transfer</span>
      </div>
      <div class="flex items-center gap-2 bg-white p-2 rounded border">
        <mat-icon class="text-purple-600">account_balance_wallet</mat-icon>
        <span class="text-sm">Digital Wallet</span>
      </div>
    </div>
  </div> -->

  <!-- Purchase Button -->
  <button [disabled]="checkoutForm.invalid || (checkoutForm.value.quantity || 0) < 1" mat-flat-button color="primary"
    class="w-fit ml-auto py-3 text-lg font-semibold">
    @if (loading()) {
    <mat-spinner diameter="20" class="mr-2"></mat-spinner>
    Processing...
    } @else {
    <ng-container>
      <mat-icon>shopping_cart</mat-icon>
      PAY {{ getTotalAmount() }} AED
    </ng-container>
    }
  </button>

  <!-- Terms -->
  <!-- <p class="text-xs text-gray-500 text-center mt-2">
    By purchasing, you agree to our
    <a href="#" class="text-blue-600 hover:underline">Terms of Service</a> and
    <a href="#" class="text-blue-600 hover:underline">Refund Policy</a>
  </p> -->
</form>
} @else {
<!-- Transaction Handler Container -->
<div class="max-w-4xl mx-auto p-4 space-y-4">

  <!-- Header -->
  <div class="bg-[#212529] flex items-center justify-between p-4 mb-4 w-full">
    <h1 class="text-lg md:text-3xl font-semibold text-white">Transactions</h1>
    <button (click)="fetchTransactionHistory()" id="refreshBtn" class="!text-white">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <!-- Filter Bar -->
  <!-- <div class="flex gap-4 items-center">
    <select id="statusFilter"
      class="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
      <option value="">All Status</option>
      <option value="complete">Complete</option>
      <option value="open">Open</option>
    </select>
    <select id="currencyFilter"
      class="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
      <option value="">All Currencies</option>
      <option value="aed">AED</option>
      <option value="inr">INR</option>
    </select>
    <input id="searchInput" type="text" placeholder="Search by email or ID..."
      class="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 flex-1">
  </div> -->

  <!-- Transaction List -->
  <div id="transactionList" class="space-y-3">
    <!-- Transaction items will be populated here -->
    @if(loading()) {
    <mat-spinner diameter="40" class="mr-2"></mat-spinner>
    } @else {
    @for(transaction of transactionsData();track transaction.id){
    <div class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
      <div class="flex justify-between items-start mb-3">
        <div class="flex-1">
          <div class="flex flex-col md:flex-row items-center gap-2 mb-1">
            <span class="font-mono text-sm text-gray-600">{{transaction.id.substring(0, 20)}}...</span>
            <div class="flex gap-1">
              <!-- <span class="px-2 py-1 rounded-full text-xs font-medium" [class]="transaction.status === 'complete' ? 'bg-green-100 text-green-800' :
                   transaction.status === 'open' ? 'bg-yellow-100 text-yellow-800' :
                   'bg-gray-100 text-gray-800'">
                {{transaction.status}}
              </span> -->
              <span class="px-2 py-1 rounded-full text-xs font-medium" [class]="transaction.payment_status === 'paid' ? 'bg-green-100 text-green-800' :
                   'bg-red-100 text-red-800'">
                {{transaction.payment_status}}
              </span>
            </div>
          </div>
          <p class="text-sm text-gray-600">{{transaction?.customer_details?.email || 'Email missing'}}</p>
          @if (transaction.customer_details.name) {
          <p class="text-sm text-gray-500">{{transaction?.customer_details?.name}}</p>
          }
        </div>
        <div class="text-right">
          <p class="text-lg font-semibold">
            {{ transaction.currency | uppercase}}
            {{ transaction.amount_total / 100 }}
          </p>
          @if (transaction.presentment_details) {
          <p class="text-sm text-gray-500">
            {{ transaction.presentment_details.presentment_currency | uppercase}}
            {{ transaction.presentment_details.presentment_amount / 100 }}
          </p>
          }
        </div>
      </div>
      <div class="flex justify-between items-center text-sm text-gray-500">
        <span>{{(transaction.created * 1000) | date:'MMM d, y, h:mm a'}}</span>
        <!-- <button class="text-blue-500 hover:text-blue-700 font-medium">
          View Details
        </button> -->
      </div>
    </div>
    }
    }
  </div>

  <!-- Empty State -->
  <div id="emptyState" class="text-center py-12 text-gray-500 hidden">
    <div class="text-4xl mb-4">💳</div>
    <p>No transactions found</p>
  </div>
</div>
}